import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { usePatient } from "../context/PatientContext";
import CONFIG from "../config";
import "../Styles/patientDetails.css";

const SelectedPatientDetails = () => {
  const { patientId } = useParams();
  const { doctorInfo } = usePatient();
  const [patient, setPatient] = useState(null);
  const [patientCases, setPatientCases] = useState([]);
  const [balance, setBalance] = useState(null);
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const response = await axios.get(`${baseURL}/patients/${patientId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE,
          },
        });
        setPatient(response.data);
      } catch (error) {
        console.error("Error fetching patient details:", error);
      }
    };

    const fetchCases = async () => {
      try {
        const response = await axios.get(`${baseURL}/patients/${patientId}/cases`, {
          headers: {
            Authorization: `Bearer ${token}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE,
          },
        });
        setPatientCases(response.data || []);
      } catch (error) {
        console.error("Error fetching patient cases:", error);
      }
    };

    const fetchBalance = async () => {
      try {
        const response = await axios.get(`${baseURL}/patients/${patientId}/balance`, {
          headers: {
            Authorization: `Bearer ${token}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE,
          },
        });
        setBalance(response.data.previous_balance || 0);
      } catch (error) {
        console.error("Error fetching patient balance:", error);
        setBalance(0);
      }
    };

    fetchPatient();
    fetchCases();
    fetchBalance();
  }, [patientId, baseURL]);

  if (!patient) return <h3>Loading...</h3>;

  return (
    <div className="patient-container">
      <div className="patient-header">
        <div className="patient-info">
          <h2>{patient.PATIENT_NAME}</h2>
          <p>ID: {patient.PATIENT_ID}</p>
        </div>

        {/* 💰 Balance Card */}
        <div className="balance-card">
          <h3>Account Balance</h3>
          <p className={balance >= 0 ? "positive" : "negative"}>
            ₹ {balance?.toLocaleString("en-IN")}
          </p>
        </div>
      </div>

      <div className="container1">
        <div className="menu">
          <button className="add-case-btn" onClick={() => navigate(`/visits/${patientId}/addcase`)}>
            ➕ Add New Case
          </button>
        </div>

        <div className="info">
          <h3>Patient Cases</h3>
          <ul className="case-list">
            {patientCases.length > 0 ? (
              patientCases.map((caseItem) => (
                <li
                  key={caseItem.CASE_ID}
                  onClick={() => navigate(`/visits/${patientId}/${caseItem.CASE_ID}`)}
                >
                  <strong>Case ID {caseItem.CASE_ID}:</strong> This is Case {caseItem.CASE_ID}
                </li>
              ))
            ) : (
              <li>No cases found</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SelectedPatientDetails;
